import React from 'react';
import ConcursoPreview from '../../components/ConcursoPreview';

const ConcursoPreviewPage = () => <ConcursoPreview />;

export default ConcursoPreviewPage;
